export default function WhySellToUsSection() {
  return (
    <div className="py-24 bg-gray-50 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-900 mb-4">
          Why Sell Your Distressed Property to TRex RE LLC?
        </h2>
        <p className="text-center text-gray-600 text-lg mb-16 max-w-3xl mx-auto">
          We're El Paso's trusted cash home buyers, helping homeowners since 2016
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-20 h-20 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-hand-coin-line text-4xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">We Are End Buyers</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              We're not middlemen or wholesalers. TRex RE LLC purchases properties directly with our own funds for our investment portfolio.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-20 h-20 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-tools-line text-4xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Buy As-Is Condition</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              No repairs needed. We buy homes in any condition - fire damage, water damage, foundation issues, you name it.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-20 h-20 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-calendar-check-line text-4xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">8+ Years of Experience</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Since 2016, we've helped hundreds of El Paso homeowners sell their properties quickly and hassle-free.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-20 h-20 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-money-dollar-box-line text-4xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">No Fees or Commissions</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Keep more money in your pocket. No realtor commissions, no closing costs, no hidden fees whatsoever.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-20 h-20 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-shield-check-line text-4xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Local El Paso Experts</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              We know the El Paso market inside and out. We're your neighbors, and we're here to help our community.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="w-20 h-20 bg-teal-100 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-speed-line text-4xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Close in 7 Days or Less</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Need to sell fast? We can close in as little as 7 days. Or take your time - we work on your schedule.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
